// admin.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { globalUser } from './helpers/globalFields';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const user = globalUser.getUser();
    const perms: string[] = user?.permissions ?? [];

    if (perms.includes('system.admin') || perms.includes('organization.admin')) {
      return true;
    }

    this.router.navigate(['/ticket/list']);
    return false;
  }
}